import React from 'react';
import { IconAdd } from '@bynder/icons';
import {
  AddSwatchColor,
  StyledColorSwatch,
} from '../shared/styled-components/Widgets';
import { WidgetPosition } from '../../constants/widgets';

interface Props {
  addColorSwatch: () => void;
  numberOfColumns: number;
  widgetPosition: WidgetPosition;
}

const AddColorSwatchButton: React.FC<Props> = ({
  widgetPosition,
  numberOfColumns,
  addColorSwatch,
}) => (
  <StyledColorSwatch
    $widgetPosition={widgetPosition}
    $numberOfColumns={numberOfColumns}
  >
    <AddSwatchColor onClick={addColorSwatch}>
      <IconAdd />
    </AddSwatchColor>
  </StyledColorSwatch>
);

export default AddColorSwatchButton;
